export default "__VITE_ASSET__faBXwcrn__"